export const AUDIT_DEPOSITS_VIEW = "LeninkaArt.Audit.Deposits.View"
export const AUDIT_EVENTS_VIEW = "LeninkaArt.Audit.Events.View"
export const AUDIT_EVENTS_EXPORT = "LeninkaArt.Audit.Events.Export"
export const AUDIT_ASSOCIATIONS_VIEW = "LeninkaArt.Audit.Associations.View"
